// extracted by mini-css-extract-plugin
export var content = "_9g-3";
export var list = "_9g-4";
export var settingsContent = "_9g-7";
export var settingsPanel = "_9g-8";
export var state = "_9g-6";
export var triggerBadge = "_9g-2";
export var triggerButton = "_9g-1";
export var triggerShell = "_9g-0";
export var unreadDot = "_9g-5";